import React, { useState, useCallback, useEffect } from 'react';
import { Button, Form, Input, Switch, Radio, Select } from 'antd';
import GatewaySelect from '../../common/GatewaySelect';
import { getProject } from '../../../api/project';
import { useRequest } from '../../../hooks';
import styles from './index.module.scss'
import { DEVICE_SN_PREFIX } from '../../../constants';

type FieldType = {
  [key: string]: any
};

const DeviceUpdate: React.FC<{
  onComplete: (values: any) => void,
  initialValues?: Partial<DeviceRecord & Device>,
  submitLoading?: boolean,
  isEdit?: boolean,
  projectId?: string | number,
}> = ({ onComplete, initialValues, submitLoading, isEdit, projectId }) => {
  const [is5G, setIs5G] = useState(initialValues?.type === '5G');
  const fetchData = useCallback(() => {
    if (!projectId) return Promise.resolve(null);
    return getProject(projectId)
  }, [projectId])

  const { data: project } = useRequest(fetchData);
  const gatewayOptions = project?.gateways?.map(i => {
    return {
      label: i.name,
      value: i.mac
    }
  });
  const [form] = Form.useForm();
  useEffect(() => {
    if (gatewayOptions?.length === 1 && form) {
      form?.setFieldValue?.("gatewayMac", gatewayOptions[0].value)
    }
  }, [gatewayOptions, form]);
  return (
    <Form
      labelCol={{ span: 8 }}
      wrapperCol={{ span: 16 }}
      style={{ maxWidth: 600 }}
      initialValues={{
        ...initialValues,
        ...initialValues?.device,
        name: initialValues?.name,
      }}
      form={form}
      onFinish={onComplete}
    >
      <Form.Item<FieldType>
        label="展馆名称"
        rules={[{ required: false }]}
      >
        <Input disabled value={project?.organizationName} />
      </Form.Item>
      <Form.Item<FieldType>
        label="展会名称"
        rules={[{ required: false }]}
      >
        <Input disabled value={project?.name} />
      </Form.Item>
      <Form.Item<FieldType>
        label="展位号"
        name="name"
        rules={[{ required: true }]}
      >
        <Input />
      </Form.Item>

      <Form.Item<FieldType>
        label="设备编号"
        name="deviceSn"
        rules={[{ required: true },
          {
            validator(_, value: string){
              return value && !(/^[A-Za-z0-9]+$/gi).test(value) ? Promise.reject(new Error('仅支持数字或英文字母,请勿输入空格或其他字符')) : Promise.resolve('')
            }
          }

        ]}
      >
        <Input prefix={isEdit ? '' : DEVICE_SN_PREFIX} className={styles.sn} />
      </Form.Item>
      <Form.Item<FieldType>
        label="二级开关号"
        name="secondSwitch"
        rules={[{ required: false }]}
      >
        <Input />
      </Form.Item>
      <Form.Item<FieldType>
        label="开关数量"
        name="switchCount"
      >
        <Input type='number' max={7} min={1} />
      </Form.Item>

      <Form.Item<FieldType>
        label="设备类型"
        name="type"
        rules={[{ required: true }]}
      >
        <Radio.Group onChange={e => {
          setIs5G(e.target.value === '5G')
        }} options={[
          {
            label: '4G', value: '4G',
          },
          {
            label: '5G', value: '5G',
          }
        ]} />
      </Form.Item>
      {
        is5G === true &&
        <Form.Item<FieldType>
          label="网关MAC地址"
          name="gatewayMac"
          rules={[{ required: true }]}
        >
          <GatewaySelect disabled={isEdit} options={gatewayOptions} />
        </Form.Item>
      }
      <Form.Item<FieldType>
        label="电箱电流(A)"
        name="electricalBoxCapacity"
        rules={[{ required: true }]}
      >
        <Select placeholder='请选择' options={[
          { value: 15, label: '15A' },
          { value: 30, label: '30A' },
          { value: 40, label: '40A' },
          { value: 60, label: '60A' },
          { value: 100, label: '100A' },
        ]} />
      </Form.Item>
      <Form.Item<FieldType>
        label="是否受控"
        name="isControlled"
      >
        <Switch />
      </Form.Item>

      <Form.Item<FieldType>
        label="24小时保电"
        name="isKeepOnline"
      >
        <Switch />
      </Form.Item>

      <Form.Item<FieldType>
        label="动力电源"
        name="isPowerSupply"
      >
        <Switch />
      </Form.Item>

      <Form.Item<FieldType>
        label="备注"
        name="description"
      >
        <Input.TextArea />
      </Form.Item>

      <Form.Item wrapperCol={{ offset: 8, span: 16 }} >
        <Button loading={submitLoading} type="primary" htmlType="submit">
          保存
        </Button>
      </Form.Item>
    </Form>
  )
}
export default DeviceUpdate;